import React from 'react';

export default function ProgressBar({ percent }: { percent: number }) {
  return (
    <div
      className="h-9 w-full animate-pulse rounded-full border"
      style={{ padding: '3px' }}
    >
      <div
        className="h-7 rounded-full bg-cloudBlue transition ease-in-out"
        // start at 10% because empty bar doesn't look like one
        style={{ width: `${percent < 90 ? percent + 10 : percent}%` }}
      />
    </div>
  );
}
